import * as React from "react";
import styled from "styled-components";
import { IMAGE_SRC } from "../../common/constants";
export interface ILoadingProps {
  className?: String;
}

export default function LoadingSpinner({ className }: ILoadingProps) {
  return (
    <StyledLoadingSpinner className="flex  justify-center ">
      <div className="lds-ring flex justify-center">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </StyledLoadingSpinner>
  );
}
const StyledLoadingSpinner = styled.div`
  .lds-ring {
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    margin: 8px;
    border: 4px solid #f3a952;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #f3a952 transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
